module.exports = __webpack_public_path__ + "static/media/background.eff4a313.png";